export default __webpack_public_path__ + "img/CaikumaSad.15fddb09.webp";